import { render } from "./ConfigProveedores.vue?vue&type=template&id=0ea5db96&scoped=true"
import script from "./ConfigProveedores.vue?vue&type=script&lang=js"
export * from "./ConfigProveedores.vue?vue&type=script&lang=js"

import "./ConfigProveedores.vue?vue&type=style&index=0&id=0ea5db96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea5db96"]])

export default __exports__